<div class="container">
	<nb-card class="blue-card mt-5">
		<div class="left-content">
			<h1 class="blue-paragraph mb-4">Lorem ipsum</h1>
			<p class="short-paragraph">
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius
				tortor nibh, sit amet tempor nibh finibus et.
			</p>
		</div>
		<div class="right-content">
			<img src="../../../../../assets/images/scenario.svg" alt="" />
		</div>
	</nb-card>
	<nb-card class="white-card mt-5">
		<h1 class="heading1 mb-4">
			SKENARI 10
		</h1>
		<p class="dark-paragraph">
			Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius
			tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.
			Vestibulum aliquam hendrerit molestie. Mauris malesuada nisi sit amet
			augue accumsan tincidunt. Maecenas tincidunt, velit ac porttitor pulvinar,
			tortor eros facilisis libero, vitae commodo nunc quam et ligula. Ut nec
			ipsum sapien. Interdum et malesuada fames ac ante ipsum primis in
			faucibus. Integer id nisi nec nulla luctus lacinia non eu turpis. Etiam in
			ex imperdiet justo tincidunt egestas. Ut porttitor urna ac augue cursus
			tincidunt sit amet sed orci. Mauris malesuada nisi sit amet augue accumsan
			tincidunt. Maecenas tincidunt, velit ac porttitor pulvinar
		</p>
	</nb-card>
	<div class="search mb-4">
		<input nbInput placeholder="Kërko numrin personal…" />
	</div>
</div>
